import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_thiagoalvarenga.png",
      alt: "Estratégias Thiago Alvarenga",
    },
    title: "Thiago Alvarenga",

    // String ou array de strings
    text: [
      "Com mais de 15 anos de experiência no Mercado, já atuei como Trader e passei pelas maiores corretoras do Brasil: XP Investimentos, Rico, MyCap e Ágora. Agora, venho compartilhar minhas estratégias mais vencedoras e consistentes ao longo dos anos, para facilitar suas operações e maximizar o retorno dos seus investimentos.",
    ],
    testimonial: {
      text: "Meu objetivo é que as operações de curto prazo potencializem os retornos de longo prazo, na construção de um patrimônio robusto",
      author: {
        name: "Thiago Alvarenga",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Kit de estratégias do Thiago",
    heading: "Mais de 15 anos de experiência à sua disposição",
    subtitle:
      "Facilite seus trades simplesmente deixando que a estratégia siga a melhor linha de risco vs. retorno, sem operações excessivas, com perdas controladas e potencial de lucro diferenciado.",
  },

  cta: {
    title: "Para começar a ter melhores resultados,",
    subtitle: "basta clicar no botão",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "Thiago Alavarenga",
    col1: [
      "Ao longo dos meus mais de 15 anos de vivência no Mercado, seja como analista, seja como trader, já passei por diversas fases: crises agudas, como sub-prime em 2008 e COVID-19 em 2020, momentos de recessão e momentos de euforia. A busca por serenidade ao operar me levou aos caminhos menos trilhados do Mercado, com uma abordagem diferenciada sobre o Day Trade e o Swing Trade. Meu propósito é ajudar aos traders de todos os níveis a terem melhores resultados no curto prazo e a construir um patrimônio sólido no longo prazo.",
    ],
    // col2: [
    //   "Nossa missão é ajudar traders de todos os níveis a aproveitar as vantagens da automação no mercado financeiro.",
    // ],
  },

  stats: {
    title: "Destaques",
    subtitle: "15 anos de experiência condensados em estratégias eficientes",
    data: [
      {
        value: "+15",
        description: "Anos operando",
      },
      {
        value: "+15k",
        description: "Horas de estudos",
      },
      {
        value: "+100k",
        description:
          "Clientes já viram as estratégias em atuação em tempo real",
      },
    ],
  },

  features: {
    title: "Por que utilizar os nossos robôs?",
    subtitle: "Veja quais as principais vantagens dos robôs Thiago Alvarenga.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossas estratégias e confira a performance em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte individual",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas de nossos clientes.",
      },
      ...defaultContent.features.data,
    ],
  },

  // testimonials: [
  //   {
  //     text: "Num mercado como o brasileiro, com baixa liquidez e interesse, movimentado principalmente por notícias políticas e econômicas.. fica essencial que seus participantes dominem seus vieses emocionais ou que transfiram tais responsabilidades para os HFT, dito isso, uma vez que você escolha a segunda opção, os robôs programados pela Factory4 são espetaculares, vale o teste!",
  //     author: "Junior Vimieiro",
  //     job: "Analista",
  //     // image_url:
  //     //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
  //   },
  //   {
  //     text: "Eu nunca imaginei que robôs poderiam fazer isso. Os robôs da Factory4 são muito bons, sem emoções. Estou feliz por ter encontrado uma solução para melhorar minha rentabilidade.",
  //     author: "Renato Terra",
  //     job: "Empresário",
  //     // image_url:
  //     //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
  //   },
  // ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Thiago Alvarenga",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
